import { POST } from "../../APiHelper/API";

export const addNewPlayers = (team_id, onSuccess, onError) => {
    const data = {}
    POST(`/api/v1/leagues/team/${team_id}/add_new_players`, data, onSuccess, onError)
}